<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="Aut"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_Aut" title="Link target outside of Sample"><span class="ePub-B">Author’s Note</span></span></p>
<p class="FMCO-1">Reader beware: All names and identifying characteristics have been changed. Certain events have been reordered and some characters and scenes are composites.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authorsnote.vue?1c18b691